import React from "react";
import { Link } from "react-router-dom";
import GetInTouchForm from "./GetInTouchForm";

/* will be used later
const useStyle = styled((theme) => ({  
  paper: {
    position: "relative",
    width: 800,
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,

    padding: theme.spacing(2, 4, 3),
  },
  cls1: {
    fill: "#fff",
  },
  cls2: {
    stroke: "#fff",
    "stroke-miterlimit": 10,
    "stroke-width": ".2px",
    fill: "#fff",
  },
  cls3: {
    fill: "#a6a6a6",
  },
  cls4: {
    fill: "#fbbc04",
  },
  cls5: {
    fill: "#4285f4",
  },
  cls6: {
    fill: "#34a853",
  },
  cls7: {
    fill: "#ea4335",
  },
})); */

const footerStyle = {
  position:'fixed'
}

const NewFooter = () => {
  // const classes = useStyle(); will be used later
  const [openGetInTouchModal, setOpenGetInTouchModal] = React.useState(false);
  return (
    <footer className="site-footer" id="siteFooter" > 
      <section className="land-footer">
        <div className="container">
          <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between">
            <div className="land-footer-buttons">
              <a
                className="land-footer-buttons-link"
                onClick={() => setOpenGetInTouchModal(true)}
              >
                Get In Touch
              </a>
            </div>
            <ul className="list-unstyled d-flex align-items-center justify-content-center land-footer-social">
              {/* 
              will be used later
              <li className="land-footer-app-store">
                <a
                  className="land-footer-app-store-link"
                  href="javascript:void(0);"
                >
                  <svg
                    id="livetype"
                    xmlns="http://www.w3.org/2000/svg"
                    width="119.66407"
                    height="40"
                    viewBox="0 0 119.66407 40"
                  >
                    <title>
                      Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917
                    </title>
                    <g>
                      <g>
                        <g>
                          <path d="M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z" />
                          <path
                            d="M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
                            style={{ fill: "#fff" }}
                          />
                        </g>
                        <g id="_Group_" data-name="&lt;Group&gt;">
                          <g id="_Group_2" data-name="&lt;Group&gt;">
                            <g id="_Group_3" data-name="&lt;Group&gt;">
                              <path
                                id="_Path_"
                                data-name="&lt;Path&gt;"
                                d="M24.99671,19.88935a5.14625,5.14625,0,0,1,2.45058-4.31771,5.26776,5.26776,0,0,0-4.15039-2.24376c-1.74624-.1833-3.43913,1.04492-4.329,1.04492-.90707,0-2.27713-1.02672-3.75247-.99637a5.52735,5.52735,0,0,0-4.65137,2.8367c-2.01111,3.482-.511,8.59939,1.41551,11.414.96388,1.37823,2.09037,2.91774,3.56438,2.86315,1.4424-.05983,1.98111-.91977,3.7222-.91977,1.72494,0,2.23035.91977,3.73427.88506,1.54777-.02512,2.52292-1.38435,3.453-2.77563a11.39931,11.39931,0,0,0,1.579-3.21589A4.97284,4.97284,0,0,1,24.99671,19.88935Z"
                              />
                              <path
                                id="_Path_2"
                                data-name="&lt;Path&gt;"
                                d="M22.15611,11.47681a5.06687,5.06687,0,0,0,1.159-3.62989,5.15524,5.15524,0,0,0-3.33555,1.72582,4.82131,4.82131,0,0,0-1.18934,3.4955A4.26259,4.26259,0,0,0,22.15611,11.47681Z"
                              />
                            </g>
                          </g>
                          <g>
                            <path d="M42.30178,27.13965h-4.7334l-1.13672,3.35645H34.42678l4.4834-12.418h2.083l4.4834,12.418H43.43752Zm-4.24316-1.54883h3.752L39.961,20.14355H39.9092Z" />
                            <path d="M55.1592,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238h1.79883v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.64455,21.34766,55.1592,23.16406,55.1592,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30178,29.01563,53.249,27.81934,53.249,25.96973Z" />
                            <path d="M65.12453,25.96973c0,2.81348-1.50635,4.62109-3.77881,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238h1.79883v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C63.6094,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91064,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26662,29.01563,63.21389,27.81934,63.21389,25.96973Z" />
                            <path d="M71.70949,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51758-3.61426,2.625,0,4.42383,1.47168,4.48438,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60547,1.626,3.60547,3.44238,0,2.32324-1.84961,3.77832-4.793,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z" />
                            <path d="M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z" />
                            <path d="M86.064,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72512,30.6084,86.064,28.82617,86.064,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40137,1.16211-2.40137,3.10742c0,1.96191.89551,3.10645,2.40137,3.10645S92.7593,27.93164,92.7593,25.96973Z" />
                            <path d="M96.18508,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z" />
                            <path d="M109.38332,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10109,25.13477Z" />
                          </g>
                        </g>
                      </g>
                      <g id="_Group_4" data-name="&lt;Group&gt;">
                        <g>
                          <path d="M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z" />
                          <path d="M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z" />
                          <path d="M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z" />
                          <path d="M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z" />
                          <path d="M59.09377,8.437h.88867v6.26074h-.88867Z" />
                          <path d="M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z" />
                          <path d="M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z" />
                          <path d="M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z" />
                          <path d="M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z" />
                          <path d="M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z" />
                          <path d="M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z" />
                          <path d="M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z" />
                          <path d="M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z" />
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
                <a
                  className="land-footer-app-store-link"
                  href="javascript:void(0);"
                >
                  <svg
                    id="artwork"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 135 40"
                  >
                    <rect width="135" height="40" rx="5" ry="5" />
                    <path
                      className={classes.cls3}
                      d="M130,.8c2.32,0,4.2,1.88,4.2,4.2v30c0,2.32-1.88,4.2-4.2,4.2H5c-2.32,0-4.2-1.88-4.2-4.2V5C.8,2.68,2.68,.8,5,.8h125M130,0H5C2.25,0,0,2.25,0,5v30c0,2.75,2.25,5,5,5h125c2.75,0,5-2.25,5-5V5C135,2.25,132.75,0,130,0h0Z"
                    />
                    <g>
                      <path
                        className={classes.cls2}
                        d="M45.98,12.75c-.33,.12-.97,.31-1.73,.31-.85,0-1.56-.22-2.11-.75-.49-.47-.79-1.22-.79-2.1,0-1.68,1.16-2.92,3.06-2.92,.65,0,1.16,.14,1.41,.26l-.18,.59c-.3-.13-.68-.24-1.25-.24-1.37,0-2.27,.85-2.27,2.27s.86,2.28,2.18,2.28c.48,0,.8-.07,.97-.15v-1.68h-1.15v-.59h1.86v2.71Z"
                      />
                      <path
                        className={classes.cls2}
                        d="M50.18,10.35h-2.2v2.04h2.45v.61h-3.17V7.35h3.05v.61h-2.32v1.78h2.2v.6Z"
                      />
                      <path
                        className={classes.cls2}
                        d="M52.76,7.97h-1.72v-.62h4.18v.62h-1.73v5.03h-.74V7.97Z"
                      />
                      <path
                        className={classes.cls2}
                        d="M58.69,7.35v5.65h-.73V7.35h.73Z"
                      />
                      <path
                        className={classes.cls2}
                        d="M61.2,7.97h-1.72v-.62h4.18v.62h-1.73v5.03h-.74V7.97Z"
                      />
                      <path
                        className={classes.cls2}
                        d="M71.23,10.12c0,1.94-1.18,2.97-2.62,2.97s-2.54-1.16-2.54-2.86c0-1.79,1.11-2.97,2.62-2.97s2.54,1.18,2.54,2.86Zm-4.38,.09c0,1.21,.65,2.29,1.8,2.29s1.81-1.06,1.81-2.35c0-1.12-.59-2.3-1.8-2.3s-1.81,1.11-1.81,2.35Z"
                      />
                      <path
                        className={classes.cls2}
                        d="M72.35,13V7.35h.8l1.81,2.86c.42,.66,.75,1.26,1.01,1.83h.02c-.07-.76-.08-1.45-.08-2.33v-2.36h.69v5.65h-.74l-1.79-2.87c-.39-.63-.77-1.27-1.06-1.88h-.03c.04,.72,.06,1.4,.06,2.34v2.41h-.69Z"
                      />
                    </g>
                    <path
                      className={classes.cls1}
                      d="M68.14,21.75c-2.35,0-4.27,1.79-4.27,4.25s1.92,4.25,4.27,4.25,4.27-1.8,4.27-4.25-1.92-4.25-4.27-4.25Zm0,6.83c-1.29,0-2.4-1.06-2.4-2.58s1.11-2.58,2.4-2.58,2.4,1.05,2.4,2.58-1.11,2.58-2.4,2.58Zm-9.31-6.83c-2.35,0-4.27,1.79-4.27,4.25s1.92,4.25,4.27,4.25,4.27-1.8,4.27-4.25-1.92-4.25-4.27-4.25Zm0,6.83c-1.29,0-2.4-1.06-2.4-2.58s1.11-2.58,2.4-2.58,2.4,1.05,2.4,2.58-1.11,2.58-2.4,2.58Zm-11.08-5.53v1.8h4.32c-.13,1.01-.47,1.76-.98,2.27-.63,.63-1.61,1.32-3.33,1.32-2.66,0-4.74-2.14-4.74-4.8s2.08-4.8,4.74-4.8c1.43,0,2.48,.56,3.25,1.29l1.27-1.27c-1.08-1.03-2.51-1.82-4.53-1.82-3.64,0-6.7,2.96-6.7,6.61s3.06,6.61,6.7,6.61c1.97,0,3.45-.64,4.61-1.85,1.19-1.19,1.56-2.87,1.56-4.22,0-.42-.03-.81-.1-1.13h-6.07Zm45.31,1.4c-.35-.95-1.43-2.71-3.64-2.71s-4.01,1.72-4.01,4.25c0,2.38,1.8,4.25,4.22,4.25,1.95,0,3.08-1.19,3.54-1.88l-1.45-.97c-.48,.71-1.14,1.18-2.09,1.18s-1.63-.43-2.06-1.29l5.69-2.35-.19-.48Zm-5.8,1.42c-.05-1.64,1.27-2.48,2.22-2.48,.74,0,1.37,.37,1.58,.9l-3.8,1.58Zm-4.62,4.12h1.87v-12.5h-1.87v12.5Zm-3.06-7.3h-.06c-.42-.5-1.22-.95-2.24-.95-2.13,0-4.08,1.87-4.08,4.27s1.95,4.24,4.08,4.24c1.01,0,1.82-.45,2.24-.97h.06v.61c0,1.63-.87,2.5-2.27,2.5-1.14,0-1.85-.82-2.14-1.51l-1.63,.68c.47,1.13,1.71,2.51,3.77,2.51,2.19,0,4.04-1.29,4.04-4.43v-7.64h-1.77v.69Zm-2.14,5.88c-1.29,0-2.37-1.08-2.37-2.56s1.08-2.59,2.37-2.59,2.27,1.1,2.27,2.59-1,2.56-2.27,2.56Zm24.38-11.08h-4.47v12.5h1.87v-4.74h2.61c2.07,0,4.1-1.5,4.1-3.88s-2.03-3.88-4.1-3.88Zm.05,6.03h-2.65v-4.29h2.65c1.4,0,2.19,1.16,2.19,2.14s-.79,2.14-2.19,2.14Zm11.53-1.8c-1.35,0-2.75,.6-3.33,1.91l1.66,.69c.35-.69,1.01-.92,1.7-.92,.96,0,1.95,.58,1.96,1.61v.13c-.34-.19-1.06-.48-1.95-.48-1.79,0-3.6,.98-3.6,2.81,0,1.67,1.46,2.75,3.1,2.75,1.25,0,1.95-.56,2.38-1.22h.06v.96h1.8v-4.79c0-2.22-1.66-3.46-3.8-3.46Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-.96,1.06-1.33,1.98-1.33,.82,0,1.21,.18,1.7,.42-.14,1.16-1.14,1.98-2.22,1.98Zm10.58-6.58l-2.14,5.42h-.06l-2.22-5.42h-2.01l3.33,7.58-1.9,4.21h1.95l5.13-11.79h-2.07Zm-16.81,8h1.87v-12.5h-1.87v12.5Z"
                    />
                    <g>
                      <path
                        className={classes.cls7}
                        d="M20.72,19.42l-10.65,11.3s0,0,0,0c.33,1.23,1.45,2.13,2.78,2.13,.53,0,1.03-.14,1.46-.4l.03-.02,11.98-6.91-5.61-6.11Z"
                      />
                      <path
                        className={classes.cls4}
                        d="M31.49,17.5h-.01s-5.17-3.01-5.17-3.01l-5.83,5.19,5.85,5.85,5.15-2.97c.9-.49,1.51-1.44,1.51-2.53s-.6-2.04-1.5-2.52Z"
                      />
                      <path
                        className={classes.cls5}
                        d="M10.07,9.28c-.06,.24-.1,.48-.1,.74V29.98c0,.26,.03,.5,.1,.74l11.01-11.01L10.07,9.28Z"
                      />
                      <path
                        className={classes.cls6}
                        d="M20.8,20l5.51-5.51L14.34,7.55c-.43-.26-.94-.41-1.49-.41-1.33,0-2.45,.91-2.78,2.13,0,0,0,0,0,0l10.73,10.72Z"
                      />
                    </g>
                  </svg>
                </a>
              </li> */}
              <li className="land-footer-social-item">
                <a
                  className="land-footer-social-link"
                  href="https://www.facebook.com/Propagile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="zmdi zmdi-facebook-box"></i>
                </a>
              </li>
              {/* <!-- Each item --> */}
              <li className="land-footer-social-item">
                <a
                  className="land-footer-social-link"
                  href="https://www.instagram.com/propagile/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="zmdi zmdi-instagram"></i>
                </a>
              </li>
              {/* <!-- Each item --> */}
              <li className="land-footer-social-item">
                <a
                  className="land-footer-social-link"
                  href="https://twitter.com/PropAgile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="zmdi zmdi-twitter"></i>
                </a>
              </li>
              {/* <!-- Each item --> */}
              <li className="land-footer-social-item">
                <a
                  className="land-footer-social-link"
                  href="https://www.linkedin.com/company/propagile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="zmdi zmdi-linkedin"></i>
                </a>
              </li>
              {/* <!-- Each item --> */}
              <li className="land-footer-social-item">
                <a
                  className="land-footer-social-link"
                  href="https://www.pinterest.com/propagile/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="zmdi zmdi-pinterest"></i>
                </a>
              </li>
              {/* <!-- Each item --> */}
              <li className="land-footer-social-item">
                <a
                  className="land-footer-social-link"
                  href="https://www.youtube.com/propagile/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="zmdi zmdi-youtube-play"></i>
                </a>
              </li>
              {/* <!-- Each item --> */}
            </ul>
            <p className="copy-right">
              2022 Propagile /<Link to="/terms">Terms of Use</Link> /{" "}
              <Link to="/privacy-policy">Privacy Policy</Link>
            </p>
          </div>
        </div>
      </section>
      {!!openGetInTouchModal && (
        <GetInTouchForm
          openGetInTouchModal={openGetInTouchModal}
          handleCloseModal={() => setOpenGetInTouchModal(false)}
        />
      )}
    </footer>
  );
};

export default NewFooter;
